<template>
  <v-container fluid class="px-0 py-0">
    <!-- 用户的基本信息显示 -->
    <template v-if="d && d.a">
      <h2>用户信息</h2>
      <ul>
        <li><label>编号</label>{{ d.a.id }}</li>
        <li><label>姓名</label>{{ d.a.name }}</li>
        <li><label>机构</label>{{ d.a.orgName }}</li>
        <li>
          <label>最后登录时间</label>{{ d.a.lastLoginTime | formatDatetime }}
        </li>
        <li><label>登录次数</label>{{ d.a.loginCount }}</li>
        <li><label>最后登录IP</label>{{ d.a.latestIps }}</li>
        <li><label>最后登录浏览器</label>{{ d.a.userAgent }}</li>
      </ul>
    </template>
    <template v-if="d && d.message">
      <h2>异常日志信息</h2>
      <ul>
        <li><label>IP</label>{{ d.message.ipChain }}</li>
        <li><label>浏览器</label>{{ d.message.userAgent }}</li>
        <li v-if="d.clazz">
          <label>培训计划</label>
          <ul>
            <li><label>名称</label>{{ d.clazz.name }}</li>
            <li v-if="d.clazz.startDate">
              <label>开始时间</label>{{ d.clazz.startDate | formatDatetime }}
            </li>
            <li v-if="d.clazz.startDate">
              <label>结束时间</label>{{ d.clazz.endDate | formatDatetime }}
            </li>
            <li>
              <label>全局培训计划</label>{{ d.clazz.global ? "是" : "否" }}
            </li>
          </ul>
        </li>
        <li v-if="d.fn"><img :src="d.fn" style="max-width: 150px" /></li>
      </ul>
    </template>
  </v-container>
</template>
<script>
export default {
  name: "stu-elog-detail",
  props: { cfg: Object },
  data() {
    return {
      d: null,
    };
  },
  methods: {
    init() {
      let self = this,
        cfg = self.cfg;
      if (cfg && cfg.id) {
        self.$axios
          .get(`/home/admin/sys/stue/log/detail/${cfg.id}`)
          .then((r) => {
            let d = r.data;
            if (d.fn) {
              d.fn = `${self.$const.baseUrl}/home/admin/sys/stue/log/img/${d.message.accountId}/${d.message.id}/${d.fn}`;
            }
            self.d = d;
          });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
label {
  color: gray;
  margin-right: 8px;
}
</style>